/**
 * Games Info Game Collection
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var BaseCollection = require('common/base.collection');
    var GamesInfoGameModel = require('portlets/games-info/gamesinfo.game.model');
    var user = require('user');
    var favoritesStore = require('stores/favorites/favorites.store.instance');

    module.exports = BaseCollection.extend({

        model: GamesInfoGameModel,

        subscribe: function() {
            if (user.isLoggedIn()) {
                this.listenTo(favoritesStore, 'change:state', this._setFavorites, this);
                this.listenTo(favoritesStore, 'add remove', this._updateGameFavoritesStatus, this);
            }
        },

        sync: function(method) {
            if (method === 'read') {
                return this._read();
            }
        },

        _read: function() {
            favoritesStore.fetch().done(this._setFavorites.bind(this));
        },

        /**
         * Mark game is added/removed from favorites
         * @private
         * @param  {Model}  model
         */
        _updateGameFavoritesStatus: function(model) {
            var favoriteID = model.get('favoriteID');
            var game = this.get(favoriteID);

            if (game) {
                game.set('isInFavorites', favoritesStore.hasItem(favoriteID));
            }
        },

        /**
         * Add info about added games marked as favorite
         * @private
         */
        _setFavorites: function() {
            favoritesStore.state.forEach(function(favorite) {
                var game = this.get(favorite.favoriteID);

                if (game && favorite.type === 'game') {
                    game.set('isInFavorites', true);
                }
            }, this);
        }
    },

    {
        /**
         * filter to games that are configured
         * @param {Array} games - array of game objects or game codes
         * @return {Array}
         */
        filterGames: function(games) {
            var isGameCodes = games && _.isString(games[0]);
            var gameConfiguration = isGameCodes
                ? _.pluck(Playtech.Variables.gamesConfiguration, 'gameCode')
                : Playtech.Variables.gamesConfiguration;
            var checkMethod = isGameCodes ? 'includes' : 'has';

            return _.filter(games, function(game) {
                return _[checkMethod](gameConfiguration, game);
            });
        }
    });
});
